export enum SupervisorQueueType {
  SET_QUEUES = "SET_QUEUES",
  SET_AGENTS = "SET_AGENTS",
  SET_SUPERVISORS = "SET_SUPERVISORS",
}
